import { useEffect, useState } from "react";
import OnOffSwitch from "../../micro_components/OnOffSwitch";
import FormTextBox from "../../micro_components/FormTextBox";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import BookDataService from "../../../services/BookService";
import { publishingApi } from "../../../services/publishingApi";
import axios from "axios";

const FALLBACK_BOOK_TYPES = [
  "GUITAR",
  "PERCUSSION",
  "PIANO",
  "VIOLIN",
  "UKULELE",
  "KAMANCHEH",
];

export default function Interlude({
  isPublishing,
  setIsPublishing,
  book,
  isNew,
  handleInputChange,
  roles,
}) {
  const [bookTypes, setBookTypes] = useState(FALLBACK_BOOK_TYPES);

  useEffect(() => {
    publishingApi
      .get("/types")
      .then((response) => {
        const types = Array.isArray(response.data)
          ? response.data.map((type) => String(type).trim().toUpperCase())
          : [];
        if (types.length > 0) {
          setBookTypes(types);
        }
      })
      .catch((error) => {
        console.log("error loading instrument types: " + error);
      });
  }, []);

  const typeValue = (book.type || "").toString().trim().toUpperCase();
  const instrumentTypes =
    typeValue && !bookTypes.includes(typeValue)
      ? [typeValue, ...bookTypes]
      : bookTypes;
  const selectedType = instrumentTypes.includes(typeValue) ? typeValue : "";

  const revalidateBook = (slug) => {
    axios.get(
      `https://www.interludescores.com/api/revalidate?path=/books/${slug}&secret=Snapple`
    );
  };

  return (
    <div>
      <div>
        <h3>Interlude:</h3>
        <OnOffSwitch
          value={isPublishing}
          handleClick={() => setIsPublishing(!isPublishing)}
        />
        <FormTextBox
          value={book.publisher}
          label="Publisher Name"
          initialValue={""}
          onChange={handleInputChange}
          name="publisher"
        />
        <FormTextBox
          value={book.price}
          label="Price"
          initialValue={""}
          onChange={handleInputChange}
          name="price"
        />
        <Box sx={{ minWidth: 120 }}>
          <FormControl variant="standard">
            <InputLabel id="book-type-label">Type (Instrument)</InputLabel>
            <Select
              variant="standard"
              labelId="book-type-label"
              id="book-type-select"
              name="type"
              value={selectedType}
              label="Type (Instrument)"
              onChange={handleInputChange}
              style={{ width: "300px" }}
              MenuProps={{
                MenuListProps: {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                  },
                },
              }}
            >
              {instrumentTypes.map((type) => (
                <MenuItem
                  key={type}
                  value={type}
                  style={{ display: "flex", width: "100%" }}
                >
                  <ListItemText primary={type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <FormTextBox
          value={book.revenue}
          label="Revenue % for publisher"
          initialValue=""
          onChange={handleInputChange}
          name="revenue"
        />
        <FormTextBox
          value={book.publishingVideo}
          label="Sample Video"
          initialValue=""
          onChange={handleInputChange}
          name="publishingVideo"
        />

        {roles.map((role, i) => {
          // console.log(role)
          return (
            <FormTextBox
              value={book[`creator${role.creator_id}`]}
              label={`Revenue % for ${role.title}`}
              initialValue=""
              onChange={handleInputChange}
              name={`creator${role.creator_id}`}
              key={i}
            />
          );
        })}

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Button
            onClick={() => revalidateBook(book.slug)}
            variant="contained"
            color="primary"
            style={{
              marginTop: "10px",
              width: "fit-content",
            }}
          >
            Refresh Book Data
          </Button>
          {isNew ? null : (
            <Button
              onClick={() => {
                BookDataService.deleteFromPublishing(book.id).then(() => {
                  revalidateBook(book.slug);
                });
              }}
              variant="contained"
              color="secondary"
              style={{ width: "fit-content" }}
            >
              Delete from Interlude
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
